/**
 * Shared contact details for WhatsApp assistant, schema, and future reuse.
 */

export const PHONE_DISPLAY = "+91 99788 22213";
export const PHONE_TEL = "+919978822213";
export const WHATSAPP_NUMBER = "919978822213";
export const EMAIL = "admin.panthievent@gmail.com";

export const ADDRESS =
  "A-107, Krish Elite, Beside HP Petrol Pump, Nr Vishal Land Mark, B/H Sankalp School, Sardar Patel Ring Rd, Nikol, Ahmedabad, Gujarat 382350";

export const MAPS_URL = "https://maps.app.goo.gl/favRGAuK3ghkg8oH6";

export const WHATSAPP_DEFAULT_GREETING =
  "Hi Panthi Events, I would like to inquire about an event.";

/** Matches Contact form event types + Concert from site menu */
export const EVENT_TYPE_OPTIONS = [
  { value: "wedding", label: "Wedding" },
  { value: "birthday", label: "Birthday" },
  { value: "corporate", label: "Corporate Event" },
  { value: "anniversary", label: "Anniversary" },
  { value: "concert", label: "Concert" },
  { value: "other", label: "Other" },
];
